import ReactMarkdown from 'react-markdown';

// Renders model-authored prose as markdown — the Scorecard / Sensitivity / Sponsor / IC-Memo
// narratives emit `##` headings, `-` bullets, and `**bold**`. Before this, the report paragraph-split
// on blank lines only, so headings and bullets showed their literal `#`/`-`/`\n` characters
// (report-visualization-spec §3.8). react-markdown does NOT render raw HTML unless rehype-raw is
// added — we add no such plugin, and constrain the output to a known-safe element allowlist below, so
// model text can never inject markup. Same renderer the Nexus Deal Room mirrors for cross-tenant parity.

// The block/inline elements the model legitimately produces. Anything outside this set (raw HTML,
// images, etc.) is dropped rather than rendered — a hardened allowlist, not a passthrough.
const ALLOWED = [
  'p',
  'h1',
  'h2',
  'h3',
  'h4',
  'strong',
  'em',
  'ul',
  'ol',
  'li',
  'blockquote',
  'code',
  'pre',
  'hr',
  'br',
  'a',
] as const;

export function Markdown({ body, className }: { body: string; className?: string }) {
  return (
    <div className={`md${className ? ` ${className}` : ''}`}>
      <ReactMarkdown
        allowedElements={ALLOWED as unknown as string[]}
        unwrapDisallowed
        components={{
          // Force any link to open safely (no opener leak) — defense in depth even though the prose
          // is our own model's output, not user input.
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
        }}
      >
        {body}
      </ReactMarkdown>
    </div>
  );
}
